import axios from './lib/axios';
import { forEach, classListToggle } from './lib/util';
import { debounce } from 'lodash';

const cancelTokens = [];

async function fetchPasswordInfo(password, id) {

   // For other applications using this Login App JS, the page should have the Login App hostname injected
   // via a meta tag. If not, assume we're calling this from Login App, and just use a relative URL.
   const loginAppUrlMetaTag = document.querySelector('meta[name="login-host"]');
   const loginAppUrl = (loginAppUrlMetaTag && loginAppUrlMetaTag.getAttribute('content')) || '';

   // cancel existing request if one exists
   if (cancelTokens[id]) {
      cancelTokens[id].cancel('Canceled request');
   }

   // get a new cancelToken for this request
   cancelTokens[id] = axios.CancelToken.source();

   const csrfMetaTag = document.querySelector('meta[name="csrf-token"]');

   return await axios({
      method: 'post',
      url: loginAppUrl + '/change_password/check',
      headers:
         // error pages don't have a csrf token; it's up to the API to refuse if needed
         csrfMetaTag ? { 'X-CSRF-TOKEN': csrfMetaTag.getAttribute('content') } : {},
      data: { password },
      cancelToken: cancelTokens[id].token,
   })
      .then(({ data, status }) => {
         if (status !== 200) {
            throw new Error('Password info fetch unsuccessful.');
         }
         return data;
      })
      .catch(e => {
         throw new Error('Could not get password info:', e?.message);
      });
}

function updatePasswordIndicator(el) {
   return data => {
      const meter = el.querySelector('meter');
      const descriptor = el.querySelector('.cuda-password-descriptor');

      // if the request was cancelled, data is undefined
      if (data) {
         meter?.setAttribute('value', data.strength + 1);

         classListToggle(el, {
            'cuda-password-info-exists': true,
            'cuda-password-info-too-short': data.too_short,
            'cuda-password-info-too-long': data.too_long,
            'cuda-password-info-too-weak': data.too_weak,
            'cuda-password-info-reused': data.reused ?? false,
            'cuda-password-info-in-blocklist': data.in_blocklist,
         });
         descriptor.innerText = data.descriptor; // great, good, acceptable, weak, poor
      }
   };
}

export function bindPasswordEvents() {
   // only show password stuff if JS can run
   forEach(document.querySelectorAll('.cuda-password-element'), el => {
      el.style.display = 'block';
   });

   // password info indicator
   forEach(document.querySelectorAll('.cuda-password-info'), el => {
      const field = el.querySelector('input');

      // create a debounced fetcher for this field
      const debouncedFetchPasswordInfo = debounce((password, el) => {
         fetchPasswordInfo(password, field?.id)
            .then(updatePasswordIndicator(el))
            .catch(error => {
               console.warn(error);
            });
      }, 500);

      // bind keyup event
      field?.addEventListener('keyup', event => {
         debouncedFetchPasswordInfo(event.target.value, el);
      });
   });
}
